/**
 * Nederlandse teksten voor de planning (scherm 4). Het advies is altijd
 * concreet: wát verplaatst er, waarheen en hoeveel kilometer scheelt dat.
 */
export const planningCopy = {
    title: 'Planning',
    eyebrow: (week: number, from: string, to: string) => `week ${week} · ${from} — ${to}`,
    eyebrowFallback: 'Planning laden',
    /** Een link naar Keuringen, gefilterd op wat nog geen afspraak heeft. */
    unscheduled: (n: number) =>
        n === 1 ? '1 keuring wacht op een afspraak' : `${n} keuringen wachten op een afspraak`,

    previousWeek: 'Vorige week',
    thisWeek: 'Deze week',
    nextWeek: 'Volgende week',
    weekNavigation: 'Week kiezen',

    inspectorFilterLabel: 'Filter op inspecteur',
    inspectorAll: 'Alle inspecteurs',

    adviceApply: 'Doorvoeren',
    adviceApplying: 'Doorvoeren…',
    adviceLabel: 'Planningsadvies',
    adviceSaved: (km: number) => `${km} km minder`,
    adviceApplied: (number: string) =>
        `Keuring ${number} is verplaatst. De klant krijgt het nieuwe tijdstip per mail.`,
    adviceExpired:
        'Dit voorstel geldt niet meer: de planning is intussen veranderd. Het bord is ververst.',

    autoSchedule: 'Automatisch inplannen',
    autoPreviewing: 'Voorstel maken…',
    /** Waarom de knop uit staat: zonder inspecteur valt er niemand in te plannen. */
    autoNeedsInspector: 'Automatisch inplannen kan zodra er een inspecteur in je team is.',
    autoTitle: 'Automatisch inplannen',
    autoIntro:
        'Dit gebeurt er als je doorvoert. Er is nog niets verplaatst en nog geen klant bericht gestuurd.',
    autoNothing: 'Er valt deze week niets in te plannen.',
    autoScheduledTitle: 'Wordt ingepland',
    autoSkippedTitle: 'Blijft liggen',
    autoLine: (number: string, who: string, when: string, km: number) =>
        `${number} · ${who} · ${when} · +${km} km`,
    autoUnknownInspector: 'inspecteur volgt',
    autoApply: (n: number) => (n === 1 ? '1 keuring inplannen' : `${n} keuringen inplannen`),
    autoApplying: 'Inplannen…',
    autoDone: (n: number) =>
        n === 1
            ? '1 keuring is ingepland. De klant krijgt de afspraak per mail.'
            : `${n} keuringen zijn ingepland. De klanten krijgen hun afspraak per mail.`,
    autoClose: 'Sluiten',

    gridLabel: 'Weekrooster per inspecteur',
    columnInspector: 'Inspecteur',
    kilometres: (km: number) => `${km} km`,
    rowSummary: (stops: number, km: number) =>
        `${stops} ${stops === 1 ? 'afspraak' : 'afspraken'} · ${Math.round(km)} km`,
    unavailable: 'Niet beschikbaar',
    stopLabel: (time: string, place: string, number: string) =>
        `${time} ${place}, keuring ${number}`,
    emptyWeek: 'Deze week staat nog niets ingepland en er zijn geen inspecteurs op het bord.',
    emptyWeekInvite: 'Inspecteur uitnodigen',
    emptyWeekNewInspection: 'Nieuwe keuring',
    /** Het inspecteursfilter staat op iemand die niet op het bord staat. */
    emptyInspector: 'Deze inspecteur staat deze week niet op het bord.',

    legendLabel: 'Diensten',
    errorTitle: 'De planning kon niet geladen worden',
} as const;
